import { getAxiosInstance } from "../../../api";

// the upload link comes from the same endpoint Create Video uses
export const getUploadLink = async (fileSize) => {
  const api = await getAxiosInstance();
  try {
    const response = await api.post("admin/get-upload-link", { file_size: fileSize });
    return response;
  } catch (error) {
    return error.response?.data ?? { status_code: 500, message: error.message };
  }
};

export const bulkUploadVideos = async (endpoint, videos, categoryId = null) => {
  const api = await getAxiosInstance();
  try {
    const response = await api.post(endpoint, {
      videos,
      ...(categoryId ? { category_id: categoryId } : {}),
    });
    return response;
  } catch (error) {
    // a missing route or a proxy error answers with an HTML page, which has no message
    // to show, so fall back to the status; the panel keeps this on screen
    const data = error.response?.data;
    return typeof data === "object" && data !== null
      ? data
      : { status_code: error.response?.status ?? 500, message: error.message };
  }
};

// shorts need a category on every record, so the panel offers the same list the
// Create Shorts form uses
export const shortsBasicData = async () => {
  const api = await getAxiosInstance();
  try {
    const response = await api.get("admin/short/basic-data");
    return response;
  } catch (error) {
    return error.response?.data ?? { status_code: 500, message: error.message };
  }
};
